import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProviderGroupState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ProviderGroupState = {
  data: [],
  isLoading: false,
  error: null,
};

const providerGroupSlice = createSlice({
  name: 'providerGroups',
  initialState,
  reducers: {
    setProviderGroups: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setProviderGroupLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setProviderGroupError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setProviderGroups, setProviderGroupLoading, setProviderGroupError } = providerGroupSlice.actions;

export default providerGroupSlice.reducer;
